import * as React from 'react';

export class ErrorMessage extends React.Component<any, any>{
    render() {
        return (
            <div className={`form__error-message ${this.props.positionRelative ? ' position_relative' : ''}`}>
                <div>{this.props.children}</div>
            </div>);
    }
}